import type { RootState } from '../../redux/store';
import type { Job } from '../../redux/features/jobs/jobsSlice';

export type TrackedJobItemKey =
  | `viewedJob#${string}`
  | `savedJob#${string}`
  | `appliedJob#${string}`;

/**
 * Which user-state bucket holds this job (applied wins over saved over viewed).
 * Used when upserting fields like `isHidden` onto the correct `*Job#` entry.
 */
export function resolveTrackedJobRef(
  jobId: string,
  state: RootState,
): { itemKey: TrackedJobItemKey; job: Job } | null {
  const applied = state.jobs.appliedJobs.find((j) => j.id === jobId);
  if (applied) return { itemKey: `appliedJob#${jobId}`, job: applied };
  const saved = state.jobs.savedJobs.find((j) => j.id === jobId);
  if (saved) return { itemKey: `savedJob#${jobId}`, job: saved };
  const viewed = state.jobs.viewedJobs.find((j) => j.id === jobId);
  if (viewed) return { itemKey: `viewedJob#${jobId}`, job: viewed };
  return null;
}

export function timestampExtrasFromJob(job: Job): Record<string, unknown> {
  const r = job as Record<string, unknown>;
  const o: Record<string, unknown> = {};
  if (r.viewedAt) o.viewedAt = r.viewedAt;
  if (r.savedAt) o.savedAt = r.savedAt;
  if (r.appliedAt) o.appliedAt = r.appliedAt;
  return o;
}
